import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

// components
import AccountMenu from '../components/shared/menu/Menu';
import { setNavigator } from './navigation';

const AppLayout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigator(navigate);
  }, [navigate]);

  return (
    <>
      <AccountMenu />
      <Outlet />
    </>
  );
};

export default AppLayout;
